import { CSSProperties } from 'react'

import { SxProps, Theme } from '@mui/material'

export const containerSx = ({
  darkVariant,
}: {
  darkVariant: boolean
}): SxProps<Theme> => {
  let sx: SxProps<Theme> = {
    padding: '2.4rem',
    gap: '1.2rem',
    borderRadius: '1.6rem',
    border: (theme) => `0.1rem solid ${theme.palette.divider}`,
  }

  if (darkVariant) {
    sx = {
      ...sx,
      background: 'rgba(0, 0, 0, 0.80)',
      color: (theme: Theme) => theme.palette.primary.contrastText,
    }
  }

  return sx
}

export const contentSx: SxProps<Theme> = {
  gap: '0.8rem',
}

export const textSx = ({
  darkVariant,
}: {
  darkVariant: boolean
}): SxProps<Theme> => {
  let sx: SxProps<Theme> = {
    fontStyle: 'italic',
  }

  if (darkVariant) {
    sx = {
      ...sx,
      fontSize: '1.6rem',
      lineHeight: '2.8rem',
      letterSpacing: '0.044rem',
    }
  }

  return sx
}

export const authorWrapperSx: SxProps<Theme> = {
  alignItems: 'center',
}

export const authorNameSx = ({
  darkVariant,
}: {
  darkVariant: boolean
}): SxProps<Theme> => {
  let sx: SxProps<Theme> = {
    lineHeight: '2rem',
  }

  if (darkVariant) {
    sx = {
      ...sx,
      fontWeight: 700,
    }
  }

  return sx
}

export const authorPositionSx = ({
  darkVariant,
}: {
  darkVariant: boolean
}): SxProps<Theme> => {
  return {
    minWidth: {
      lg: 'max-content',
    },
    color: (theme) =>
      darkVariant
        ? theme.palette.primary.contrastText
        : theme.palette.text.secondary,
  }
}

export const quotesIconSx: CSSProperties = {
  minWidth: '6rem',
  minHeight: '4.26rem',
  marginTop: '-0.4rem',
}
